export default {
      id: "agility-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#agility",
      toString: function () {
        return this.url;
      }
    }